import { Component, Input, OnInit } from "@angular/core";
import { NotificationService } from "../notification/notification.service";

type CallbackFunction = () => void;
@Component({
  selector: "app-csv-download-button",
  templateUrl: "./csv-download-button.component.html",
  styleUrls: ["./csv-download-button.component.css"],
})
export class CsvDownloadButtonComponent implements OnInit {
  @Input() downloadTemplateCallback: CallbackFunction;
  @Input() disabled: boolean;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {}

  downloadTemplate(): void {
    try {
      this.downloadTemplateCallback();
    } catch (e) {
      this.notificationService.error("Something went wrong. Try again later");
    }
  }
}
